import React from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import type { CalendarConflictAlertItem } from './calendarUtils';

interface CalendarExternalConflictAlertProps {
  visible: boolean;
  conflicts: CalendarConflictAlertItem[];
  onDismiss?: () => void;
}

export const CalendarExternalConflictAlert: React.FC<CalendarExternalConflictAlertProps> = ({
  visible,
  conflicts,
  onDismiss
}) => {
  const { t } = useTranslation('manage');

  if (!visible || conflicts.length === 0) {
    return null;
  }

  const footer = t('appointmentComponents.conflictAlert.footer');

  const description =
    conflicts.length === 1 ? (
      <>
        {t('appointmentComponents.conflictAlert.description', {
          externalLabel: conflicts[0].externalLabel,
          appointmentName: conflicts[0].appointmentName,
          weekday: conflicts[0].weekday,
          date: conflicts[0].date,
          timeRange: conflicts[0].timeRange
        })}
      </>
    ) : (
      <>
        <p style={{ margin: '0 0 8px' }}>
          {t('appointmentComponents.conflictAlert.summary', { count: conflicts.length })}
        </p>
        <ul style={{ margin: '0 0 8px', paddingLeft: 20 }}>
          {conflicts.map((conflict, index) => (
            <li key={`${conflict.overlapDayKey}-${conflict.timeRange}-${index}`}>
              {t('appointmentComponents.conflictAlert.item', {
                externalLabel: conflict.externalLabel,
                appointmentName: conflict.appointmentName,
                weekday: conflict.weekday,
                date: conflict.date,
                timeRange: conflict.timeRange
              })}
            </li>
          ))}
        </ul>
        <p style={{ margin: 0 }}>{footer}</p>
      </>
    );

  return (
    <Alert
      type="error"
      showIcon
      closable={!!onDismiss}
      onClose={onDismiss}
      title={t('appointmentComponents.conflictAlert.title')}
      description={description}
      style={{ marginBottom: 16 }}
    />
  );
};
